module.exports = __webpack_public_path__ + "static/media/electricity.ec96963d.svg";